import React, { useCallback, useEffect, useState } from "react";
import Modal from "@material-ui/core/Modal";
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  makeStyles,
  Switch,
  Typography,
} from "@material-ui/core";
import { SelectBox, TextInput } from "../../../UIkit";
import { registerUser } from "../../../../reducks/users/operations";
import { useDispatch, useSelector } from "react-redux";

import DialogButton from "../../../UIkit/DialogButton";
import LanguageIcon from "@mui/icons-material/Language";
import { getDepartments } from "../../../../reducks/department/selectors";
import { fetchdepartments } from "../../../../reducks/department/operations";
import SelectWorker from "../../../User/SelectWorker";
import {
  PERMISSIONS,
  PERMISSIONS_LIST,
} from "../../../../constants/permissions";
import {
  INITAL_DAYS,
  timeTable,
  weekDays,
} from "../../../../constants/initialSendMail";
import SelectBoxForFilter from "../../../UIkit/SelectBoxForFilter";
import SelectOrderEmail from "../../../User/SelectOrderEmail";
const useStyle = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#f0f2f5",
    padding: "20px",
    borderRadius: "5px",
    width: "90vw",
    maxWidth: "520px",
    overflow: "auto",
    maxHeight: "99vh",
  },
  buttons: {
    display: "flex",
    gap: "20px",
    justifyContent: "center",
  },
  title: {
    textAlign: "center",
    color: "#4dd0e1",
    fontSize: "20px",
    marginBottom: "20px",
  },
  caution: {
    color: "#ff0000",
    fontSize: "14px",
  },
  userNumber: {
    display: "flex",
    alignItems: "center",
    marginTop: "20px",
    padding: "0 10px",
  },
  languageButton: {
    marginTop: "20px",
    width: "24px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#757575",
  },
  selectBox: {
    padding: "0 10px",
    marginBottom: "-10px",
  },
  switch: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 40px 0 0",
  },
  sendTime: {
    width: "80px",
  },
  textInput: {
    padding: "0 10px",
  },
  switchBase: {
    "&$checked": {
      color: theme.palette.primary.main,
    },
  },
  checked: {}, // checkedの状態に必要な空クラス
  track: {
    "$checked + &": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  checkbox: {
    color: "#757575", // uncheckedの色を指定
    "&.Mui-checked": {
      color: "#4dd0e1", // checkedの色を指定
    },
  },
  label: {
    fontSize: "14px", // ラベルのフォントサイズを変更
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  weekDayLabel: {
    marginRight: "10px",
  },
  sendMail: {
    marginTop: "20px",
  },
  sendDays: {
    margin: "0 10px",
  },
}));
const AddUserForm = (props) => {
  const { setIsShow } = props;

  const dispatch = useDispatch();
  const [showSelectUser, setShowSelectUser] = useState(false);
  const [showSelectEmail, setShowSelectEmail] = useState(false);
  const [open, setOpen] = useState(true);
  const classes = useStyle();
  const handleClose = () => {
    setIsShow(false);
    setOpen(false);
  };

  const [username, setUsername] = useState(""),
    [email, setEmail] = useState(""),
    [role, setRole] = useState(PERMISSIONS.NORMAL_USER),
    [usernumber, setUsernumber] = useState(""),
    [userdepnumber, setUserdepnumber] = useState(""),
    [userdepname, setUserdepname] = useState(""),
    [orderBaseId, setOorderBaseId] = useState(""),
    [orderBaseName, setOrderBaseName] = useState(""),
    [orderDepId, setOrderDepId] = useState(""),
    [orderDepName, setOrderDepName] = useState(""),
    [orderEmail, setOrderEmail] = useState(""),
    [isSend, setIsSend] = useState(false),
    [sendTime, setSendTime] = useState("20:00"),
    [days, setDays] = useState(INITAL_DAYS),
    [sign, setSign] = useState("");

  const departmentsOnFirestore = useSelector(getDepartments);
  const [departments, setDepartments] = useState([]);
  useEffect(() => {
    dispatch(fetchdepartments());
  }, [dispatch]);
  useEffect(() => {
    const departmentList = departmentsOnFirestore.map((department) => {
      return {
        order_department_id: department.did,
        order_department_name: department.name,
        order_base_id: department.base_id,
        order_base_name: department.base_name,
        name: department.base_name + " " + department.name,
        id: department.did,
      };
    });
    setDepartments(departmentList);
  }, [departmentsOnFirestore]);
  //メモ化
  const inputUsername = useCallback(
    (event) => {
      // setUsername(event.target.value);
    },
    [setUsername]
  );
  const inputEmail = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [setEmail]
  );

  const inputRole = useCallback(
    (value) => {
      setRole(value);
    },
    [setRole]
  );
  const inputOrderEmail = useCallback(
    (e) => {
      setOrderEmail(e.target.value);
    },
    [setOrderEmail]
  );
  const inputSign = useCallback(
    (e) => {
      setSign(e.target.value);
    },
    [setSign]
  );
  const inputOrderDepartmentInfo = useCallback(
    (value) => {
      setOrderDepId(value);
      setOrderDepName(
        departments.find((department) => department.id === value)
          .order_department_name
      );
      setOorderBaseId(
        departments.find((department) => department.id === value).order_base_id
      );
      setOrderBaseName(
        departments.find((department) => department.id === value)
          .order_base_name
      );
    },
    [setOrderDepId, setOrderDepName, departments]
  );
  const handleLanguageButtonClick = () => {
    setShowSelectUser(true);
  };
  const handleEmailButtonClick = () => {
    setShowSelectEmail(true);
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={classes.root}>
          <h2 className={classes.title}>ユーザー登録</h2>
          <>
            <div className={classes.userNumber}>
              <TextInput
                fullWidth={true}
                label={"ユーザー情報"}
                multiline={false}
                required={true}
                minRows={1}
                value={username + " " + userdepname}
                type={"text"}
                disabled={false}
                onChange={inputUsername}
              />
              <button
                className={classes.languageButton}
                onClick={handleLanguageButtonClick}
              >
                <LanguageIcon />
              </button>
            </div>
            <div className={classes.selectBox}>
              <SelectBox
                label={"発注部署"}
                options={departments}
                required={true}
                select={inputOrderDepartmentInfo}
                value={orderDepId}
              />
            </div>
            <div className={classes.userNumber}>
              <TextInput
                fullWidth={true}
                label={"発注担当者メールアドレス"}
                multiline={false}
                required={true}
                minRows={1}
                value={orderEmail}
                type={"email"}
                onChange={inputOrderEmail}
              />
              <button
                className={classes.languageButton}
                onClick={handleEmailButtonClick}
              >
                <LanguageIcon />
              </button>
            </div>
            <div className="module-spacer--extra-extra-small"></div>
            <div className={classes.selectBox}>
              <SelectBox
                label={"権限"}
                options={PERMISSIONS_LIST}
                required={true}
                select={inputRole}
                value={role}
              />
            </div>
            <div className={classes.textInput}>
              <TextInput
                fullWidth={true}
                label={"メールアドレス"}
                multiline={false}
                required={true}
                minRows={1}
                value={email}
                type={"email"}
                onChange={inputEmail}
              />
            </div>
            <div className={classes.textInput}>
              <TextInput
                fullWidth={true}
                label={"メール署名"}
                multiline={true}
                required={true}
                rows={4}
                value={sign}
                type={"text"}
                disabled={false}
                onChange={inputSign}
                placeholder={"発注メール送信時の署名を入力してください"}
              />
            </div>
            <div className={classes.sendMail}>
              <p className={classes.noticeTitle}>通知設定</p>
              <div className={classes.switch}>
                <FormControlLabel
                  label={
                    <Typography className={classes.label}>
                      {isSend ? "通知する" : "通知しない"}
                    </Typography>
                  }
                  labelPlacement="start"
                  control={
                    <Switch
                      checked={isSend}
                      onChange={(e) => setIsSend(e.target.checked)}
                      classes={{
                        switchBase: classes.switchBase,
                        checked: classes.checked,
                        track: classes.track,
                      }}
                    />
                  }
                />
                <div className={classes.sendTime}>
                  <SelectBoxForFilter
                    label={"通知時刻"}
                    options={timeTable()}
                    required={true}
                    select={(value) => setSendTime(value)}
                    value={sendTime}
                    width={"100px"}
                    height={"30px"}
                    fontSize={"16px"}
                    disabled={!isSend}
                  />
                </div>
              </div>
              <p className={classes.sendDays}>通知日</p>
              <div className={classes.checkboxes}>
                {days.map((day, index) => (
                  <FormControlLabel
                    key={index}
                    label={
                      <Typography className={classes.weekDayLabel}>
                        {weekDays[index]}
                      </Typography>
                    }
                    labelPlacement="start"
                    control={
                      <Checkbox
                        classes={{ root: classes.checkbox }}
                        edge="start"
                        checked={days[index].isSend}
                        tabIndex={-1}
                        disableRipple
                        onChange={(e) => {
                          const newDays = [...days];
                          newDays[index].isSend = e.target.checked;
                          setDays(newDays);
                        }}
                        inputProps={{
                          "aria-label": "Select all rows on current page",
                        }}
                        disabled={!isSend}
                      />
                    }
                  />
                ))}
              </div>
            </div>
            <div className="module-spacer--medium" />
          </>
          <div className={classes.buttons}>
            <DialogButton
              label={"登録する"}
              onClick={async () => {
                const result = await dispatch(
                  registerUser(
                    username,
                    email,
                    usernumber,
                    userdepnumber,
                    userdepname,
                    orderBaseId,
                    orderBaseName,
                    orderDepId,
                    orderDepName,
                    role,
                    orderEmail,
                    sign,
                    isSend,
                    sendTime,
                    days
                  )
                );
                if (result) {
                  handleClose();
                }
              }}
              mode="yes"
            />
            <DialogButton
              label={"キャンセル"}
              onClick={handleClose}
              mode="no"
            />
          </div>
          {showSelectUser && (
            <SelectWorker
              username={username}
              setUsername={setUsername}
              usernumber={usernumber}
              setUsernumber={setUsernumber}
              userdepnumber={userdepnumber}
              setUserdepnumber={setUserdepnumber}
              userdepname={userdepname}
              setUserdepname={setUserdepname}
              setShowSelectUser={setShowSelectUser}
              email={email}
              setEmail={setEmail}
            />
          )}
          {showSelectEmail && (
            <SelectOrderEmail
              email={orderEmail}
              setEmail={setOrderEmail}
              setShowSelectEmail={setShowSelectEmail}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default AddUserForm;
